export default {
    menu_mobile_open: false
}